import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';

import { TenantApiService } from '../../../services/tenant-api.service';

import { Tenant } from '../../../types/tenant.types';
import { DetailResponse } from '@synegen/utility';

export const tenantResolver: ResolveFn<DetailResponse<Tenant> | null> = (route) => {
  let id = route.paramMap.get('id');

  return inject(TenantApiService).getTenant(Number(id), ['domain']);
};
